export function initAccordionWithImg(wrapper = document) {
    const accordions = wrapper.querySelectorAll('.js-accordionWithImg');

    accordions.forEach(accordion => {
        const items = accordion.querySelectorAll('.accordionWithImg__item');
        const imageWrappers = accordion.querySelectorAll('.accordionWithImg__imageWrapper');

        const openItem = (item) => {
            const index = item.dataset.index;

            items.forEach(i => {
                i.classList.remove('is-open');
                i.removeAttribute('aria-current');
                const trigger = i.querySelector('.accordionWithImg__trigger');
                const panel = i.querySelector('.accordionWithImg__body');
                trigger.setAttribute('aria-expanded', 'false');
                panel.setAttribute('hidden', '');
            });

            imageWrappers.forEach(img => img.classList.remove('is-active'));

            item.classList.add('is-open');
            item.setAttribute('aria-current', 'true');
            const trigger = item.querySelector('.accordionWithImg__trigger');
            const panel = item.querySelector('.accordionWithImg__body');
            trigger.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');

            const matchingImage = accordion.querySelector(`.accordionWithImg__imageWrapper[data-index="${index}"]`);
            if (matchingImage) {
                matchingImage.classList.add('is-active');
            }
            setTimeout(function () {
                const subHeader = document.querySelector('.dcSubHeader');
                const offset = (subHeader ? subHeader.offsetHeight : 0) + 32;
                if (trigger.getBoundingClientRect().top < offset) {
                    window.scrollTo({ top: window.scrollY + trigger.getBoundingClientRect().top - offset, behavior: 'smooth' });
                }
            }, 100);
        };

        // open first item on init
        if (items.length > 0) {
            openItem(items[0]);
        }

        items.forEach(item => {
            const trigger = item.querySelector('.accordionWithImg__trigger');
            trigger.addEventListener('click', () => {
                if (item.classList.contains('is-open')) {
                    return;
                }
                openItem(item);
            });
        });
    });
}
